/**
 * Code generated by "npm run build-assets"
 * Figma URL: https://nda.ya.ru/t/GtheTqjX6Uejyx
 */

import {ImageAssetMeta, SrcSet} from '@yandex-delivery/assets'

import img1x from './courier@1x.png'
import img2x from './courier@2x.png'
import img3x from './courier@3x.png'

export const courier: ImageAssetMeta = {
  width: 72,
  height: 104,
  srcSet: new SrcSet(img1x, img2x, img3x),
}
